'use client';
import { isVehicleType } from '@/helpers/utils';
import { TablesVehiclePriceProps } from '@/interfaces/result';
import Image from 'next/image';
import { use } from 'react';
import { Anotation } from '../anotation/anotation.component';
import { Checkbox } from '../checkbox/checkbox.component';
import { FipeAverages } from '../fipe-averages/fipe-averages.component';
import { ResultContext } from '../pages/result/result.context';
import { ResultButtons } from '../result-buttons/result-buttons.component';
import ResultDropdownUF from '../results/result-dropdown.component';
import { WebmotorsAverages } from '../wm-averages/wm-averages.component';
import './tables-vehicle-price.scss';

export function TablesVehiclePriceComponent({
    data,
    params: { state, model, brand, version, year, type },
}: Readonly<TablesVehiclePriceProps>) {

    const { isVehicle0km, isVehicleArmored, setIsVehicle0km, setIsVehicleArmored } = use(ResultContext);

    const isCar = isVehicleType(type, 'car');

    const hasDataRegionalWm = Array.isArray(data.wm?.state_price) && data?.wm?.state_price.length > 0 && data?.wm?.state_price.some(item => item?.medium_price);
    const hasDataBrazilWm = Array.isArray(data?.wm?.brazilian_price) && data?.wm?.brazilian_price.length > 0 && data?.wm?.brazilian_price.some(item => item.medium_price);

    const hasDataFipe = data?.fipe?.new || data?.fipe?.used;
    const hasDataWm = hasDataRegionalWm || hasDataBrazilWm;

    return (
        <div className="result-tables__container" data-testid="result-tables-container" id="result-tables-container">
            {!hasDataWm && !hasDataFipe ? (
                <Anotation
                    text="Ops! Não encontramos valores de referência."
                    data-testid="anotation-no-data"
                />
            ) : (
                <>
                    <div className="result-checkboxes" data-testid="result-checkboxes" id="result-checkboxes">
                        <Checkbox
                            disabled={isVehicleArmored}
                            onClick={() => setIsVehicle0km(!isVehicle0km)}
                            checked={isVehicle0km}
                            id="result-checkbox__vehicle-0km"
                            data-testid="checkbox-vehicle-0km"
                            label="Veículo 0km"
                        />

                        {isCar && (
                            <Checkbox
                                disabled={isVehicle0km}
                                onClick={() => setIsVehicleArmored(!isVehicleArmored)}
                                checked={isVehicleArmored}
                                id="result-checkbox__vehicle-armored"
                                data-testid="checkbox-vehicle-armored"
                                label="Veículo Blindado"
                            />
                        )}
                    </div>
                    <div className="result-tables__content" data-testid="result-tables-content" id="result-tables-content">
                        <div className="result-fipe" data-testid="result-fipe" id="result-fipe">
                            <Image
                                className="result-fipe__logo"
                                width={59}
                                height={33}
                                alt="FIPE"
                                src={`${process.env.NEXT_PUBLIC_ASSETS_PATH}/assets/img/icon/brand-fipe.svg`}
                                priority
                                data-testid="result-fipe-logo"
                                id="result-fipe-logo"
                            />
                            <div className="result-fipe__value" data-testid="result-fipe-value" id="result-fipe-value">
                                <FipeAverages
                                    prices={data.fipe}
                                    isVehicle0km={isVehicle0km}
                                    isVehicleArmored={isVehicleArmored}
                                />
                            </div>
                        </div>

                        <div className="result-wm" data-testid="result-wm" id="result-wm">
                            <Image
                                className="result-wm__logo"
                                width={172}
                                height={33}
                                alt="Webmotors"
                                src={`${process.env.NEXT_PUBLIC_ASSETS_PATH}/assets/img/icon/brand-wm.svg`}
                                priority
                                data-testid="result-wm-logo"
                                id="result-wm-logo"
                            />
                            <div className="result-wm__value" data-testid="result-wm-value" id="result-wm-value">
                                <WebmotorsAverages
                                    prices={data.wm}
                                    isVehicle0km={isVehicle0km}
                                    isVehicleArmored={isVehicleArmored}
                                />
                            </div>
                        </div>
                    </div>
                    <ResultDropdownUF vehicleType={type} />
                </>
            )}

            <ResultButtons
                brand={brand}
                model={model}
                version={version}
                year={year}
                state={state}
                type={type}
                data-testid="result-buttons"
            />
        </div>
    );
}